export const sortingType = { cy: 'sorting-stye-button' };
export const typeSelected = { cy: 'type-selected-button' };
export const selectBiteItemDataSet = { cy: 'select-bite-item' };
export const selectQuizItemDataSet = { cy: 'select-quiz-item' };
export const selectPlaylistItemDataSet = { cy: 'select-playlist-item' };
